module.exports = __webpack_public_path__ + "static/media/textIcon.735ee139.svg";